import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractApiErrorMessage } from '../../shared/utils/extract-api-error-message.util';
import { Organization } from '../types/organization.type';
import { ADMIN_ORGANIZATIONS_API_PATHS } from '../constants/organizations-paths.constants';

type UpdateOrganizationDeliveryPointsParams = {
  organizationId: string;
  deliveryPointIds: string[];
};

type UseUpdateOrganizationDeliveryPointsResult = {
  isUpdating: boolean;
  updateOrganizationDeliveryPoints: (params: UpdateOrganizationDeliveryPointsParams) => Promise<Organization | null>;
};

export function useUpdateOrganizationDeliveryPoints(): UseUpdateOrganizationDeliveryPointsResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isUpdating, setIsUpdating] = useState(false);

  const updateOrganizationDeliveryPoints = async (
    params: UpdateOrganizationDeliveryPointsParams
  ): Promise<Organization | null> => {
    setIsUpdating(true);

    try {
      const updatedOrganization = await HttpClient.patch<Organization>(
        ADMIN_ORGANIZATIONS_API_PATHS.UPDATE_ORGANIZATION(params.organizationId),
        { deliveryPointIds: params.deliveryPointIds }
      );

      return updatedOrganization;
    } catch (error) {
      enqueueSnackbar(
        extractApiErrorMessage(
          error,
          "Une erreur est survenue lors de la mise à jour des points de livraison de l'organisation"
        ),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsUpdating(false);
    }
  };

  return { isUpdating, updateOrganizationDeliveryPoints };
}
